import { AxiosResponse } from "axios";
import { api } from "./base/api";
import { Result } from "../models/common/resultResponse";
import { CategoryResponse } from "../models/response";
import { ISubcategoryApi } from "./base/subcategoryApi";
import { SubcategoryRequest } from "../models/request/subcategoryRequest";

const baseRoute: string = "PartSubCategory";

export class SubcategoryApi extends ISubcategoryApi {
	getDomain(request: SubcategoryRequest): Promise<AxiosResponse<Result<CategoryResponse[]>>> {
		return api.post(`${baseRoute}/domain`, request);
	}
}
